<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cidadãos sem equipe"
            description="Cidadãos sem vinculação com qualquer equipe"
            url="/gestao-cadastros"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao=""
            pageIdentifier="cidadaos-sem-equipe"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.cidadaos_sem_equipe_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.cidadaos_sem_equipe_ajuda || 0
            "
            keyAjudaModalInformacao="cidadaos_sem_equipe_ajuda"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="estabelecimentos"
              label="no_unidade_saude"
              placeholder="Unidade de saúde"
              v-model="estabelecimento"
              :loading="loadingEstabelecimentos"
              :disabled="loadingEstabelecimentos"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_unidade_saude }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'

export default {
  name: 'CidadaosSemEquipe',
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaCadastros,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  data() {
    return {
      loading: false,
      cadastros: [],
      cadastrosOriginais: [],
      filterSearchTable: false,
      loadingEstabelecimentos: false,
      estabelecimentos: [],
      estabelecimento: null,
    }
  },
  watch: {
    /**
     * Filtra os cidadãos pelo CNES do estabelecimento selecionado.
     * Considera o CNES do último atendimento ou o CNES do cadastro.
     *
     * @param {Object|null} novoEstabelecimento Estabelecimento selecionado
     */
    estabelecimento(novoEstabelecimento) {
      this.filterSearchTable = false

      if (!novoEstabelecimento) {
        this.cadastros = [...this.cadastrosOriginais]
        return
      }

      const cnesSelecionado = String(novoEstabelecimento.nu_cnes)

      this.cadastros = this.cadastrosOriginais.filter((item) => {
        const cnesAtendimento = String(item.cnes_atend ?? '')
        const cnesCadastro = String(item.cnes_cadastro ?? '')

        return (
          cnesAtendimento === cnesSelecionado ||
          cnesCadastro === cnesSelecionado
        )
      })
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarEstabelecimentos() {
      try {
        this.loadingEstabelecimentos = true
        let response = await this.$api.get(
          `/app/municipio/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data.filter(
            (estabelecimento) => Number(estabelecimento.is_aps) !== 1
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingEstabelecimentos = false
      }
    },

    /**
     * Buscar dados
     */
    async buscarDadosIniciais() {
      try {
        this.loading = true

        let cidadados_desatualizados = await this.$api.get(
          '/app/cidadaos-sem-equipe/' + this.$store.state.cod_ibge
        )
        this.cadastros = []
        this.cadastros = cidadados_desatualizados.data
        this.cadastrosOriginais = cidadados_desatualizados.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Inicializa os dados
     */
    init() {
      this.buscarDadosIniciais()
    },
  },
  async created() {
    await this.carregarEstabelecimentos()
    this.init()
  },
}
</script>

<style scoped lang="scss"></style>
